import {ENDPOINTS} from '@/config/constants'
import api, {HTTPMethod} from '@/helpers/api'
import {pathBuilder} from '@/helpers/pathBuilder'
import {
  GetEmailTemplateByIdRequest,
  GetEmailTemplateByIdRequestSchema,
  GetEmailTemplateByIdResponse,
  GetEmailTemplateByIdResponseSchema,
  GetEmailTemplatesRequest,
  GetEmailTemplatesRequestSchema,
  GetEmailTemplatesResponse,
  GetEmailTemplatesResponseSchema,
} from '@/types/EmailTemplate'

export const getEmailTemplatesService = (params: GetEmailTemplatesRequest, signal?: AbortSignal) => {
  return api<GetEmailTemplatesRequest, GetEmailTemplatesResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_EMAIL_TEMPLATES,
    requestSchema: GetEmailTemplatesRequestSchema,
    responseSchema: GetEmailTemplatesResponseSchema,
    signal,
  })(params)
}

export const getEmailTemplateByIdService = (id: string, signal?: AbortSignal) => {
  return api<GetEmailTemplateByIdRequest, GetEmailTemplateByIdResponse>({
    method: HTTPMethod.GET,
    path: pathBuilder(ENDPOINTS.LOAD_EMAIL_TEMPLATE).withId(id).build(),
    requestSchema: GetEmailTemplateByIdRequestSchema,
    responseSchema: GetEmailTemplateByIdResponseSchema,
    signal,
  })()
}
